import * as React from "react";
function SearchIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9.02128" cy="9.02128" r="6.70634" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="transparent" />
            <path d="M13.6858 14.0342L16.3151 16.6566" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>;
}
export default SearchIcon;